import React, { useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCompanyStore } from 'stores';
// api
import { getDetailOrderProfile } from 'api/orders';
// context
import { useGlobalContext } from 'context/globalContext';
// constants
import { COIN } from '../../constants';
import { formatOrderLineBookConditionDisplay, orderLinesConditionColumnI18nKey } from 'utils/bookCondition';
// styles
import './orders.scss';

function OrderDetail() {
  const { t } = useTranslation('detalle');
  const { setIsLoading } = useGlobalContext();
  const { name } = useCompanyStore();
  const [orderDetail, setOrderDetail] = useState(null);
  let { pk } = useParams();

  useEffect(() => {
    window.document.title = 'Detalle del Pedido | ' + name;
  }, [orderDetail]);

  useEffect(() => {
    const handleDetailOrder = async () => {
      const rs = await getDetailOrderProfile(pk);
      if (rs.status === 200) {
        const { data } = rs;
        setOrderDetail(data);
        setIsLoading(false);
      }
    };
    handleDetailOrder();
  }, [pk]);

  const calcTotal = () => {
    let itemsTotal = 0;
    if (orderDetail !== null) {
      orderDetail.items.forEach((el) => {
        itemsTotal += el.total;
      });
    }
    return itemsTotal + parseInt(orderDetail.shipping_cost) + orderDetail.iva;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [orderDetail]);

  return (
    <Container fluid className="px-0 mainDiv">
      {orderDetail ? (
        <>
          <Row className="px-2 mx-0">
            <Col md={12} className="pl-1">
              <h1 className="page-title static-title mt-4 openSansItalic">Pedido</h1>
            </Col>
          </Row>
          <Container fluid className="px-0 mx-0">
            <Row className="justify-content-center px-2 mx-0 orderTable">
              <Col lg={12}>
                <h5 className="mb-3">Resumen del pedido</h5>
                <Row className="tableTitle">
                  <Col lg={4} md={4} className="tableBorder">
                    <h6>PRODUCTO</h6>
                  </Col>
                  <Col lg={2} md={2} className="tableBorder">
                    <h6>{t(orderLinesConditionColumnI18nKey(orderDetail.items))}</h6>
                  </Col>
                  <Col lg={3} md={3} className="tableBorder">
                    <h6>UNIDADES</h6>
                  </Col>
                  <Col lg={3} md={3} className="tableBorder">
                    <h6>SUBTOTAL</h6>
                  </Col>
                </Row>
                {orderDetail.items.length !== 0 &&
                  orderDetail.items.map((el, value) => (
                    <Row key={value} className="borderBottom">
                      <Col lg={4} md={4} className="">
                        <span>{orderDetail.items[value].nombre}</span>
                      </Col>
                      <Col lg={2} md={2} className="">
                        <span>{formatOrderLineBookConditionDisplay(orderDetail.items[value], (k) => t(k))}</span>
                      </Col>
                      <Col lg={3} md={3} className="">
                        <span>{orderDetail.items[value].cantidad}</span>
                      </Col>
                      <Col lg={3} md={3} className="">
                        <span>{orderDetail.items[value].total} {COIN}</span>
                      </Col>
                    </Row>
                  ))}
                {orderDetail !== null && (
                  <Row className="borderBottom">
                    <Col lg={4} md={4} className=""></Col>
                    <Col lg={2} md={2} className=""></Col>
                    <Col lg={3} md={3} className="">
                      <h6>Subtotal:</h6>
                    </Col>
                    <Col lg={3} md={3} className="">
                      <span className="orange">{orderDetail.total} {COIN}</span>
                    </Col>
                  </Row>
                )}
                {orderDetail !== null && (
                  <Row className="borderBottom">
                    <Col lg={4} md={4} className=""></Col>
                    <Col lg={2} md={2} className=""></Col>
                    <Col lg={3} md={3} className="">
                      <h6>Impuestos:</h6>
                    </Col>
                    <Col lg={3} md={3} className="">
                      <span>{orderDetail.iva} {COIN}</span>
                    </Col>
                  </Row>
                )}
                {orderDetail !== null && (
                  <Row className="borderBottom">
                    <Col lg={4} md={4} className=""></Col>
                    <Col lg={2} md={2} className=""></Col>
                    <Col lg={3} md={3} className="">
                      <h6>Gastos de envío:</h6>
                    </Col>
                    <Col lg={3} md={3} className="">
                      <span>{orderDetail.shipping_cost} {COIN}</span>
                    </Col>
                  </Row>
                )}
                {orderDetail !== null && (
                  <Row className="">
                    <Col lg={4} md={4} className=""></Col>
                    <Col lg={2} md={2} className=""></Col>
                    <Col lg={3} md={3} className="">
                      <h3>Total:</h3>
                    </Col>
                    <Col lg={3} md={3} className="">
                      <h3 className="orange">{calcTotal().toFixed(2)} {COIN}</h3>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Container>
        </>
      ) : (
        <Row>
          <Col>
            <div>
              <p>Cargando información</p>
            </div>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export default OrderDetail;
